/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import React from "react";
import { Alert, Box, Stack } from "@mui/material";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";

import { Typography } from "@mui/material";

import { Button } from "@mui/material";
import { Effect, ModalBase } from "../../utils/Interfaces";
import { useWindowDimensions } from "../../utils/Hooks";

export interface ConfirmDeleteModalProps extends ModalBase {
    description: string;
    onAccept: Effect;
    variant: "info" | "warning" | "error";
    yesText?: string;
    noText?: string;
}

const ConfirmModal = (props: ConfirmDeleteModalProps) => {
    const { description, onAccept, variant, open, handleClose, yesText = "Yes", noText = "No" } = props;

    const { width } = useWindowDimensions();

    function close() {
        handleClose();
    }

    return (
        <Modal
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
            open={open}
            onClose={close}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 500 }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        backgroundColor: (theme) => theme.palette.background.paper,
                        border: "1px solid #000",
                        boxShadow: (theme) => theme.shadows[5],
                        padding: (theme) => theme.spacing(2, 4, 3),
                        zIndex: 1000,
                        maxWidth: width < 600 ? "100%" : width < 1000 ? "80%" : "60%",
                    }}
                >
                    <Alert severity={variant}>
                        <Typography align="center" marginBottom={1}>
                            {description}
                        </Typography>
                    </Alert>
                    <Box sx={{ mb: 2 }} />

                    <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 2 }}>
                        <Button onClick={close} variant="contained" color="secondary">
                            {noText}
                        </Button>
                        <Button
                            variant="contained"
                            color={variant}
                            onClick={() => {
                                close();
                                onAccept();
                            }}
                        >
                            {yesText}
                        </Button>
                    </Stack>
                </Box>
            </Fade>
        </Modal>
    );
};

export default ConfirmModal;
